import * as AnalyticsService from "../../../shared/services/analytics/AnalyticsService";
import getDeliveryStatus from "../../../utils/DeliveryStatusUtils/GetDeliveryStatus";
import VehicleNameplateMap from "./VehicleNameplateMap";

function generateStatusMessage(result) {
  return result !== undefined
    ? getDeliveryStatus(result?.deliveryAppointment).message.toLowerCase()
    : "no info available";
}

function trackOrderDetailsPageLoad(
  result,
  orderId,
  modelYear,
  nameplate,
  user
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:${mappedNameplate}`,
    `fv:emp:customer handling details`,
    `emp:customer handling:status:${generateStatusMessage(result)}`,
    `emp:customer handling:order id:${orderId}`,
    user,
    modelYear,
    mappedNameplate
  );
}

function trackOrderDetailsPageAction(
  result,
  action,
  orderId,
  modelYear,
  nameplate,
  user
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackOnClickDetailEvent(
    `fv:emp:customer handling details:${action}:${mappedNameplate}`,
    `emp:customer handling:status:${generateStatusMessage(result)}`,
    `emp:customer handling:order id:${orderId}`,
    orderId,
    `emp:customer handling details:content:${action}`,
    `fv:emp:customer handling details:content action:${mappedNameplate}`,
    user,
    null,
    modelYear,
    mappedNameplate
  );
}

function trackPurchaseRequestDecisionPopupLoad(
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:purchase request popup:${mappedNameplate}`,
    `fv:emp:customer handling details:purchase request popup`,
    "emp:customer handling details:purchase request popup",
    `emp:customer handling:order id:${orderId}`,
    user,
    modelYear,
    mappedNameplate
  );
}

function trackAcceptPurchaseRequestPopupLoad(
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:accept purchase popup:${mappedNameplate}`,
    `fv:emp:customer handling details:accept purchase popup`,
    "emp:customer handling details:accept purchase popup",
    `emp:customer handling:order id:${orderId}`,
    user,
    modelYear,
    mappedNameplate
  );
}

function trackAcceptPurchaseRequestPopupAction(
  paymentType,
  orderId,
  orderCreatedDate,
  user,
  modelYear,
  nameplate
) {
  let paymentTypeTag;
  if (
    paymentType === "ThirdPartyFinancingOptions" ||
    paymentType === "thirdpartyfinancingoptions"
  ) {
    paymentTypeTag = "dealer finance";
  } else {
    paymentTypeTag = paymentType.toLowerCase() || "";
  }

  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackOnClickDetailEvent(
    `fv:emp:customer handling details:accept purchase popup:${mappedNameplate}`,
    `emp:customer handling details:accept purchase popup:${paymentTypeTag}:order id:${orderId}`,
    `emp:customer handling:order created:${orderCreatedDate || ""}`,
    orderId,
    "emp:customer handling details:accept purchase popup:content:confirm",
    `fv:emp:customer handling details:accept purchase popup:content action:${mappedNameplate}`,
    user,
    paymentTypeTag.toLowerCase(),
    modelYear,
    mappedNameplate
  );
}

function trackCancelPurchaseRequestPopupLoad(
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:cancel purchase popup:${mappedNameplate}`,
    `fv:emp:customer handling details:cancel purchase popup`,
    `emp:customer handling details:cancel purchase popup`,
    `emp:customer handling:order id:${orderId}`,
    user,
    modelYear,
    mappedNameplate
  );
}

function trackCancelPurchaseRequestPopupAction(
  dealerRejectedReason,
  paymentType,
  orderId,
  orderCreatedDate,
  user,
  modelYear,
  nameplate
) {
  let paymentTypeTag;
  if (
    paymentType === "ThirdPartyFinancingOptions" ||
    paymentType === "thirdpartyfinancingoptions"
  ) {
    paymentTypeTag = "dealer finance";
  } else {
    paymentTypeTag = paymentType.toLowerCase() || "";
  }

  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackOnClickDetailEvent(
    `fv:emp:customer handling details:cancel purchase popup:${mappedNameplate}`,
    `emp:customer handling details:cancel purchase:${dealerRejectedReason}:${paymentTypeTag}:order id:${orderId}`,
    `emp:customer handling:order created:${orderCreatedDate || ""}`,
    orderId,
    "emp:customer handling details:cancel purchase popup:content:confirm",
    `fv:emp:customer handling details:cancel purchase popup:content action:${mappedNameplate}`,
    user,
    paymentTypeTag.toLowerCase(),
    modelYear,
    mappedNameplate
  );
}

function trackDealerNotesDrawerLoad(orderId, user, modelYear, nameplate) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:dealer notes drawer:${mappedNameplate}`,
    `fv:emp:customer handling details:dealer notes drawer`,
    "emp:customer handling details:dealer notes drawer",
    `emp:customer handling:order id:${orderId}`,
    user,
    modelYear,
    mappedNameplate
  );
}

function trackDealerNotesDrawerAction(
  action,
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackOnClickDetailEvent(
    `fv:emp:customer handling details:dealer notes drawer:${mappedNameplate}`,
    `emp:customer handling details:dealer notes drawer`,
    `emp:customer handling:order id:${orderId}`,
    orderId,
    `emp:customer handling details:dealer notes drawer:content:${action}`,
    `fv:emp:customer handling details:dealer notes drawer:content action:${mappedNameplate}`,
    user,
    null,
    modelYear,
    nameplate
  );
}

function trackPurchaseDepositDecisionPopupLoad(
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:purchase deposit popup:${mappedNameplate}`,
    `fv:emp:customer handling details:purchase deposit popup`,
    `emp:customer handling details:purchase deposit popup`,
    `emp:customer handling:order id:${orderId}`,
    user,
    modelYear,
    mappedNameplate
  );
}

function trackAcceptPurchaseDepositPopupLoad(
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:accept purchase deposit popup:${mappedNameplate}`,
    `fv:emp:customer handling details:accept purchase deposit popup`,
    `emp:customer handling details:accept purchase deposit popup`,
    `emp:customer handling:order id:${orderId}`,
    user,
    modelYear,
    mappedNameplate
  );
}

function trackAcceptPurchaseDepositPopupAction(
  action,
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);
  AnalyticsService.trackOnClickDetailEvent(
    `fv:emp:customer handling details:accept purchase deposit popup:${mappedNameplate}`,
    "emp:customer handling details:accept purchase deposit popup",
    `emp:customer handling:order id:${orderId}`,
    orderId,
    `emp:customer handling details:accept purchase deposit popup:content:${action}`,
    "fv:emp:customer handling details:accept purchase deposit popup:content action",
    user,
    null,
    modelYear,
    mappedNameplate
  );
}

function trackRejectPurchaseDepositPopupLoad(
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);
  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:reject purchase deposit popup:${mappedNameplate}`,
    `fv:emp:customer handling details:reject purchase deposit popup`,
    `emp:customer handling details:reject purchase deposit popup`,
    `emp:customer handling:order id:${orderId}`,
    user,
    modelYear,
    mappedNameplate
  );
}

function trackRejectPurchaseDepositPopupAction(
  action,
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackOnClickDetailEvent(
    `fv:emp:customer handling details:reject purchase deposit popup:${mappedNameplate}`,
    `emp:customer handling details:reject purchase deposit popup`,
    `emp:customer handling:order id:${orderId}`,
    orderId,
    `emp:customer handling details:reject purchase deposit popup:content:${action}`,
    `fv:emp:customer handling details:reject purchase deposit popup:content action:${mappedNameplate}`,
    user,
    null,
    modelYear,
    mappedNameplate
  );
}

function trackRefundPurchaseDepositPopupLoad(
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:refund deposit popup:${mappedNameplate}`,
    `fv:emp:customer handling details:refund deposit popup`,
    `emp:customer handling details:refund deposit popup`,
    `emp:customer handling:order id:${orderId}`,
    user,
    modelYear,
    mappedNameplate
  );
}

function trackRefundPurchaseDepositPopupAction(
  action,
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);
  AnalyticsService.trackOnClickDetailEvent(
    `fv:emp:customer handling details:refund deposit popup:${mappedNameplate}`,
    "emp:customer handling details:refund deposit popup",
    `emp:customer handling:order id:${orderId}`,
    orderId,
    `emp:customer handling details:refund deposit popup:content:${action}`,
    `fv:emp:customer handling details:refund deposit popup:content action:${mappedNameplate}`,
    user,
    null,
    modelYear,
    mappedNameplate
  );
}

function trackEVPowerPromisePopupLoad(orderId, user) {
  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:ford power promise popup`,
    `emp:customer handling details`,
    `emp:customer handling details:ford power promise popup`,
    `emp:customer handling:order id:${orderId}`,
    user
  );
}

function trackEVPowerPromisePopupAction(action, orderId, user) {
  AnalyticsService.trackOnClickDetailEvent(
    "fv:emp:customer handling details:ford power promise popup",
    "emp:customer handling details:ford power promise popup",
    `emp:customer handling:order id:${orderId}`,
    orderId,
    `emp:customer handling details:ford power promise popup:content:${action}`,
    "fv:emp:customer handling details:ford power promise popup:content action",
    user
  );
}

function trackTimeOfSaleReportPopupLoad(orderId, user) {
  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:time of sale report popup`,
    `emp:customer handling details`,
    `emp:customer handling details:time of sale report popup`,
    `emp:customer handling:order id:${orderId}`,
    user
  );
}

function trackTimeOfSaleReportPopupAction(action, orderId, user) {
  AnalyticsService.trackOnClickDetailEvent(
    "fv:emp:customer handling details:time of sale report popup",
    "emp:customer handling details:time of sale report popup",
    `emp:customer handling:order id:${orderId}`,
    orderId,
    `emp:customer handling details:time of sale report popup:content:${action}`,
    "fv:emp:customer handling details:time of sale report popup:content action",
    user
  );
}

// step 1
function trackConfirmTradeInDetailsPopupLoad(
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);
  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:confirm trade in details popup:${mappedNameplate}`,
    `fv:emp:customer handling details:confirm trade in details popup`,
    `emp:customer handling details:confirm trade in details popup`,
    `emp:customer handling:order id:${orderId}`,
    user,
    modelYear,
    mappedNameplate
  );
}

function trackConfirmTradeInDetailsPopupAction(
  action,
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);
  AnalyticsService.trackOnClickDetailEvent(
    `fv:emp:customer handling details:confirm trade in details popup:${mappedNameplate}`,
    "emp:customer handling details:confirm trade in details popup",
    `emp:customer handling:order id:${orderId}`,
    orderId,
    `emp:customer handling details:confirm trade in details popup:content:${action}`,
    "fv:emp:customer handling details:confirm trade in details popup:content action",
    user,
    null,
    modelYear,
    mappedNameplate
  );
}

// step 2
function trackTradeInDecisionPopupLoad(orderId, user, modelYear, nameplate) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:trade in decision popup:${mappedNameplate}`,
    `fv:emp:customer handling details:trade in decision popup`,
    `emp:customer handling details:trade in decision popup`,
    `emp:customer handling:order id:${orderId}`,
    user,
    modelYear,
    mappedNameplate
  );
}

function trackTradeInDecisionPopupAction(
  action,
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackOnClickDetailEvent(
    `fv:emp:customer handling details:trade in decision popup:${mappedNameplate}`,
    "emp:customer handling details:trade in decision popup",
    `emp:customer handling:order id:${orderId}`,
    orderId,
    `emp:customer handling details:trade in decision popup:content:${action}`,
    "fv:emp:customer handling details:trade in decision popup:content action",
    user,
    null,
    modelYear,
    mappedNameplate
  );
}

function trackDecisionAction(action, decision, orderId, user) {
  switch (decision) {
    case "accept-and-keep":
      trackAcceptTradeInAndKeepVehiclePopupAction(action, orderId, user);
      break;
    case "accept-and-send":
      trackAcceptTradeInAndSendToAuctionPopupAction(action, orderId, user);
      break;
    case "reject":
      trackRejectTradeInPopupAction(action, orderId, user);
      break;
    default:
      // eslint-disable-next-line no-console
      console.error("Invalid decision type");
  }
}

// step 3
function trackAcceptTradeInAndKeepVehiclePopupLoad(
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:accept trade in and keep vehicle popup:${mappedNameplate}`,
    `fv:emp:customer handling details:accept trade in and keep vehicle popup`,
    `emp:customer handling details:accept trade in and keep vehicle popup`,
    `emp:customer handling:order id:${orderId}`,
    user,
    modelYear,
    mappedNameplate
  );
}

function trackAcceptTradeInAndKeepVehiclePopupAction(
  action,
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackOnClickDetailEvent(
    `fv:emp:customer handling details:accept trade in and keep vehicle popup:${mappedNameplate}`,
    `emp:customer handling details:accept trade in and keep vehicle popup`,
    `emp:customer handling:order id:${orderId}`,
    orderId,
    `emp:customer handling details:accept trade in and keep vehicle popup:content:${action}`,
    "fv:emp:customer handling details:accept trade in and keep vehicle popup:content action",
    user,
    null,
    modelYear,
    mappedNameplate
  );
}

// step 3
function trackAcceptTradeInAndSendToAuctionPopupLoad(
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:accept and send to auction:customer info popup:${mappedNameplate}`,
    "fv:emp:customer handling details:accept and send to auction:customer info popup",
    `emp:customer handling details:accept and send to auction:customer info popup`,
    `emp:customer handling:order id:${orderId}`,
    user,
    modelYear,
    mappedNameplate
  );
}

function trackAcceptTradeInAndSendToAuctionPopupAction(
  action,
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackOnClickDetailEvent(
    `fv:emp:customer handling details:accept and send to auction:customer info popup:${mappedNameplate}`,
    `emp:customer handling details:accept and send to auction:customer info popup`,
    `emp:customer handling:order id:${orderId}`,
    orderId,
    `emp:customer handling details:accept and send to auction:customer info popup:content:${action}`,
    "fv:emp:customer handling details:accept and send to auction:customer info popup:content action",
    user,
    null,
    modelYear,
    mappedNameplate
  );
}

// step 3
function trackRejectTradeInPopupLoad(orderId, user, modelYear, nameplate) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackCustomerHandlingPageLoadDetailEvent(
    `fv:emp:customer handling details:reject trade in popup:${mappedNameplate}`,
    `fv:emp:customer handling details:reject trade in popup`,
    `emp:customer handling details:reject trade in popup`,
    `emp:customer handling:order id:${orderId}`,
    user,
    modelYear,
    mappedNameplate
  );
}

function trackRejectTradeInPopupAction(
  action,
  orderId,
  user,
  modelYear,
  nameplate
) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackOnClickDetailEvent(
    `fv:emp:customer handling details:reject trade in popup:${mappedNameplate}`,
    `emp:customer handling details:reject trade in popup`,
    `emp:customer handling:order id:${orderId}`,
    orderId,
    `emp:customer handling details:reject trade in popup:content:${action}`,
    "fv:emp:customer handling details:reject trade in popup:content action",
    user,
    modelYear,
    mappedNameplate
  );
}

function track3pfLoadDetailsClick(orderId, user, modelYear, nameplate) {
  const mappedNameplate = VehicleNameplateMap.getFormattedNameplate(nameplate);

  AnalyticsService.trackOnClickDetailEvent(
    `fv:emp:customer handling details:${mappedNameplate}`,
    `emp:customer handling:status:no info available`,
    `emp:customer handling:order id:${orderId}`,
    orderId,
    "emp:customer handling details:content:financing:third party financing click here",
    `fv:emp:customer handling details:content action:${mappedNameplate}`,
    user,
    "dealer finance",
    modelYear,
    mappedNameplate
  );
}

export {
  trackRejectTradeInPopupAction,
  trackRejectTradeInPopupLoad,
  trackAcceptTradeInAndSendToAuctionPopupAction,
  trackAcceptTradeInAndSendToAuctionPopupLoad,
  trackAcceptTradeInAndKeepVehiclePopupAction,
  trackAcceptTradeInAndKeepVehiclePopupLoad,
  trackDecisionAction,
  trackOrderDetailsPageLoad,
  trackOrderDetailsPageAction,
  trackPurchaseRequestDecisionPopupLoad,
  trackAcceptPurchaseRequestPopupLoad,
  trackAcceptPurchaseRequestPopupAction,
  trackCancelPurchaseRequestPopupLoad,
  trackCancelPurchaseRequestPopupAction,
  trackDealerNotesDrawerLoad,
  trackDealerNotesDrawerAction,
  trackAcceptPurchaseDepositPopupLoad,
  trackAcceptPurchaseDepositPopupAction,
  trackRejectPurchaseDepositPopupLoad,
  trackRejectPurchaseDepositPopupAction,
  trackRefundPurchaseDepositPopupLoad,
  trackRefundPurchaseDepositPopupAction,
  trackEVPowerPromisePopupLoad,
  trackEVPowerPromisePopupAction,
  trackTimeOfSaleReportPopupLoad,
  trackTimeOfSaleReportPopupAction,
  trackConfirmTradeInDetailsPopupLoad,
  trackConfirmTradeInDetailsPopupAction,
  trackTradeInDecisionPopupLoad,
  trackTradeInDecisionPopupAction,
  trackPurchaseDepositDecisionPopupLoad,
  track3pfLoadDetailsClick,
};
